import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalConstants } from '../app/global-config';
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { TranslateService } from '@ngx-translate/core';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})
export class ServiceService {
  public server = GlobalConstants.apiURL;
  private _refeshneeded$ = new Subject<void>();

  getrefeshneeded$() {
    return this._refeshneeded$;
  }
  constructor(private http: HttpClient,) { }

  template_list = (id, is_nps = false) => {
    return this.http.get(this.server + "api/categories/getonecategoryTemplates/" + id + "?is_nps=" + is_nps);
  }

  getdata() {  // For category list in header 
    return this.http.get(this.server + "api/categories/getAll");
  }

  getBlog() {
    return this.http.get(this.server + "api/blog/get_all_blogs");
  }
  updateBlogById(id,view_count){
    return this.http.get(this.server + "api/blog/update_blog/view_count/"+id+"/"+view_count);

  }

  getSingleBlog(bid) {
    return this.http.get(this.server + "api/blog/get_blog_by_id/" + bid);

  }

  template_question_list(id) {
   
    return this.http.get(this.server + "api/templates/templateGetAllData/" + id).pipe(
      tap(() => {
        this._refeshneeded$.next();
      })
    );
  }

  selected_category(id) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append("x-access-token", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Njk2MywiaWF0IjoxNjEzNTY3MzI4LCJleHAiOjE2MjEzNDMzMjh9.Pl78DfCIwkUTEKLUjX9lkxp3CyVlZdBqYfoqEnKNLFI");
    return this.http.get(this.server + "api/categories/get/" + id, { headers });
  }

  // book a demo apis
  email_book_details(email_sent) {
    return this.http.post(this.server + "api/auth/send_mail_api", email_sent);

  }

  bookDemo(demoData) {
    return this.http.post(this.server + "api/bookDemo/createDemoRequest",  demoData )
  }

  // user_thanks(data) {
  //   // return this.http.post(this.server + "api/auth/send_mail_users" , data);
  //   return this.http.post("http://localhost:8090/api/auth/send_mail_users" , data);
  // }


  getInTouchMail(email_sent) {
    return this.http.post(this.server + "api/auth/getintouchapi", email_sent);

  }

  template_count(id) {
    return this.http.get(this.server + "api/templates/Templatequestioncount/" + id);
  }

  pricing() {
    return this.http.get(this.server + "api/plans-and-pricing");
  }

  currency() {
    return this.http.get("https://free.currconv.com/api/v7/convert?q=INR_USD&compact=ultra&apiKey=e7958e6e816cc18e7211");
  }

  discount() {
    return this.http.get(this.server + "api/plans-and-pricing/discounts");
  }

  getEncryptKey(planInfo) {
    const secreteCode = "cview120";
    //for encryption
    const cryptoInfo = CryptoJS.AES.encrypt(JSON.stringify(planInfo), secreteCode).toString();
    //for dencryption
    const info2 = CryptoJS.AES.decrypt(cryptoInfo, secreteCode).toString(CryptoJS.enc.Utf8);
    // console.log({ info2 });
    let encrypted = cryptoInfo;

    // let generatedKey = 'U2FsdGVkX19X5txibbAysoKLi4tKEjasVHV+x5Cyo6k/9GT+/lVDzbc2C1naH4gzFNsGrg+HhIOHT/5GTFenMLGd2xcgWpgxkgTMdXqCVJuoVCA5cz4jbhe7WauOb8xmxnZIn2GoeEXLyAIrmOJcI8pAnFNYLqf26CawM6ZD2wM='
    let replacedkeyByDollerAlpha = encrypted.split('+').join('xMl3Jk');
    replacedkeyByDollerAlpha = replacedkeyByDollerAlpha.split('/').join('Por21Ld');
    replacedkeyByDollerAlpha = replacedkeyByDollerAlpha.split('=').join('Ml32');
    console.log('replacedkeyByDollerAlpha Key :', replacedkeyByDollerAlpha);
    return replacedkeyByDollerAlpha;
  }
//===================================================================================================

//---------------------------------Get Plan with all services API---------------------------------------------------
planWithServices() {
  let headers: HttpHeaders = new HttpHeaders();
  headers = headers.append("x-access-token", sessionStorage.getItem("token"));
  //get plan API
  return this.http.get(this.server + "api/sadmin/plans-pricing", { headers });
}


//---------------------------------After Active Plan Refresh data API---------------------------------------------------
refresh() {
  return this._refeshneeded$;
}


//---------------------------------Redirect to Payment API---------------------------------------------------
pay(data) {
  let headers: HttpHeaders = new HttpHeaders();
  headers = headers.append("x-access-token", sessionStorage.getItem("token"));
  return this.http.post(this.server + `api/payment/stripe/create-transaction`, data, { headers });
}

//---------------------------------Get All Plan Deatails API---------------------------------------------------
getAllPlanDeatailsOnPricingPage() {
  let headers: HttpHeaders = new HttpHeaders();
  headers = headers.append("x-access-token", sessionStorage.getItem("token"));
  return this.http.get(this.server + "api/plans-and-pricing", { headers })
}
//---------------------------------Transaction Details API---------------------------------------------------
pricingg(countryCode) {
  let headers: HttpHeaders = new HttpHeaders();
  // headers = headers.append("x-access-token", sessionStorage.getItem("token"));
  headers = headers.append("country-code",countryCode);
  // return this.http.get(this.server + "api/plans-and-pricing", { headers });
  return this.http.get(this.server + "api/plans-and-pricing", { headers });
}
//--------------------------------- API--------------------------------------
//--------------------------------- API--------------------------------------
//--------------------------------- API--------------------------------------
//--------------------------------- API--------------------------------------
//--------------------------------- API--------------------------------------
//--------------------------------- API--------------------------------------
//--------------------------------- API--------------------------------------
//--------------------------------- API--------------------------------------

//--------------------------------- API--------------------------------------
getAllActiveAndAvailableUserApi(companyId){
  let headers: HttpHeaders = new HttpHeaders();
  headers = headers.append("x-access-token", sessionStorage.getItem("token"));
  return this.http.get(this.server + 'api/user-services/company/'+companyId+'/active-user-counts/', { headers }); 
}
//--------------------------------- API--------------------------------------
getCurrentIPAddress() {
  return this.http.get('https://api.ipify.org/?format=json');
  }
//--------------------------------- API--------------------------------------
getContryCodeByIP(ipJson) {
return this.http.post<any>(this.server + `api/auth/country-code-by-ip`, ipJson);
}
//--------------------------------- API--------------------------------------
getPlanPriceAccordingToCountry(currentCountryCode){
  let headers: HttpHeaders = new HttpHeaders();
  headers = headers.append("x-access-token", sessionStorage.getItem("token"));
 
  return this.http.get(this.server + "api/cadmin/get-plan-price-according-to-country/"+currentCountryCode,{ headers });

}
//--------------------------------- API--------------------------------------
PlanCurrencyDetails(planId){
  let headers: HttpHeaders = new HttpHeaders();
  headers = headers.append("x-access-token", sessionStorage.getItem("token")); 
  return this.http.get(this.server + "api/sadmin/get-plan-currency-details/plan/"+planId,{ headers });
}
//--------------------------------- API--------------------------------------
//--------------------------------- API--------------------------------------
//--------------------------------- API--------------------------------------
AllPublicServices(){
let headers: HttpHeaders = new HttpHeaders();
// headers = headers.append("x-access-token", sessionStorage.getItem("token")); 
return this.http.get(this.server + "api/plans-and-pricing/all-services");
}

//----------------------------------- API ------------------------------------
_getPlanModulesWithServices(){
return this.http.get(this.server + `api/plans-pricing/module-types-with-services-by-reordering`); 
}
//----------------------------------- API ------------------------------------
getAllQuestionTypes() {
  return this.http.get(this.server + "api/questionType/get-all-question-types");
}
//----------------------------------- API ------------------------------------
//----------------------------------- API ------------------------------------
//----------------------------------- API ------------------------------------
//----------------------------------- API ------------------------------------
//----------------------------------- API ------------------------------------
//----------------------------------- API ------------------------------------
//----------------------------------- API ------------------------------------
//----------------------------------- API ------------------------------------
//----------------------------------- API ------------------------------------
//----------------------------------- API ------------------------------------
//===================================================================================================
}




